import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import Field from '../../Wizard/Field/Field';
import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';

function EditCustomerModal(props) {
    const auth = useAuth();
    const t = useTranslate();  
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    const [editCustomer, setEditCustomer] = useState({
        apArNo: "",
            
        organizationName: "",
        companyRegistrationId: "",
        shortName: "",
        countryCodeOrg: "",
    
        addressType: "",
        firstname: "",
        lastname: "",
        contactPosition: "",
        address: "",
        city: "", 
        province: "", 
        postcode: "",
        countryCode: "",
        email: "",
        phone: "",

        ehfUser: false,
    } as any);

    const setEditApArNo = value => { setEditCustomer(editCustomer => ({...editCustomer, apArNo: value})); }

    //const [editCustomerOrganization, setEditCustomerOrganization] = useState("");
    const setEditOrganizationName = value => { setEditCustomer(editCustomer => ({...editCustomer, organizationName: value})); }
    const setEditCompanyRegistrationId = value => { setEditCustomer(editCustomer => ({...editCustomer, companyRegistrationId: value})); }
    // const setEditShortName = value => { setEditCustomer(editCustomer => ({...editCustomer, shortName: value})); }
    // const setEditCountryCodeOrg = value => { setEditCustomer(editCustomer => ({...editCustomer, countryCodeOrg: value})); }

    // const setEditAddressType = value => { setEditCustomer(editCustomer => ({...editCustomer, addressType: value})); }
    const setEditFirstName = value => { setEditCustomer(editCustomer => ({...editCustomer, firstname: value})); }
    const setEditLastName = value => { setEditCustomer(editCustomer => ({...editCustomer, lastname: value})); }
    const setEditContactPosition = value => { setEditCustomer(editCustomer => ({...editCustomer, contactPosition: value})); }
    const setEditAddress = value => { setEditCustomer(editCustomer => ({...editCustomer, address: value})); }
    const setEditCity = value => { setEditCustomer(editCustomer => ({...editCustomer, city: value})); }
    // const setEditProvince = value => { setEditCustomer(editCustomer => ({...editCustomer, province: value})); }
    const setEditPostcode = value => { setEditCustomer(editCustomer => ({...editCustomer, postcode: value})); }
    // const setEditCountryCode = value => { setEditCustomer(editCustomer => ({...editCustomer, countryCode: value})); }
    const setEditEmail = value => { setEditCustomer(editCustomer => ({...editCustomer, email: value})); }
    const setEditPhone = value => { setEditCustomer(editCustomer => ({...editCustomer, phone: value})); }

    const setEditEhfUser = value => { setEditCustomer(editCustomer => ({...editCustomer, ehfUser: value})); }

    // const updateAddressType = event => setEditAddressType(event.target.value);

    const[checkIfPrivatePerson, setCheckIfPrivatePerson] = useState(false); 

    //const [autoCompleteOptions, setAutoCompleteOptions] = useState<Array<any>>([]);
    //const [newOrgOptions, setNewOrgOptions] = useState<Array<any>>([]);

    function clearForm(){
        setEditCustomer(undefined);
    }

    async function fetchData(){
        if(props.customerId != undefined){
            axios.all([
                axios.single({
                    method: "get",
                    url: "/api/customers/" + props.customerId,
                    responseType: "json",
                    headers: {'x-access-token': auth.user["token"]}
                })
            ]).then(axios.spread((...res) => {
                setEditCustomer(res[0].data);
                if(res[0].data["companyRegistrationId"] != undefined && res[0].data["companyRegistrationId"] != ""){
                    setCheckIfPrivatePerson(false);
                }else {
                    setCheckIfPrivatePerson(true)
                }
            }))
            .catch(err => console.log(err));
        }
    }

    function createDownloadFiles(file, fileName, fileType){
        const blob = new Blob( [file], { type: 'text/plain' } );
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = fileName + "." + fileType;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    }

    function sendToInvoicing() {
        isValid().then(() => {
            handleEditCustomer().then(() => {
                axios.single({
                    method: "post",
                    url: "/api/invoicing/sendcustomer",
                    responseType: "json",
                    data: { customerId: props.customerId },
                    headers: {'x-access-token': auth.user["token"]}
                }).then(res => {
                    axios.single({
                        method: "post",
                        url: "/api/invoicing/sendCustomerFileExternal",
                        responseType: "json",
                        data: { customerId: props.customerId },
                        headers: {'x-access-token': auth.user["token"]}
                    }).then(res => {
                        notifySuccess(t("customer.sendToInvoicingSuccess"));
                        fetchData();
                    }).catch(err => {
                        notifyWarning(t("customer.sendToInvoicingFailed"));
                        createDownloadFiles(err.response.data.file.file, "customer", "xml");
                    });
                })
                .catch(err => {
                    notifyWarning(t("customer.sendToInvoicingFailed"));
                });
            }).catch(err => {
                notifyWarning(t("customer.sendToInvoicingFailed"));
            });
        }).catch(err => {
            notifyWarning(t("customer.sendToInvoicingFailed"));
        });
    }

    function isValid() {
        return new Promise((resolve, reject) => {
            let isOnlyNumPattern = new RegExp(/^[[0-9]*$/);
            let valid = true;

            if (!checkIfPrivatePerson) { // If not private person
                if (editCustomer["organizationName"] == undefined || editCustomer["organizationName"] == "") { notifyWarning(t("customers.toast.empty_organization_name")); valid = false; }
                if (editCustomer["companyRegistrationId"] == undefined || editCustomer["companyRegistrationId"] == "") { notifyWarning(t("customers.toast.empty_company_registration_id")); valid = false; }
                if (
                    editCustomer["companyRegistrationId"] !== undefined &&
                    editCustomer["companyRegistrationId"] !== "" &&
                    !isOnlyNumPattern.test(editCustomer["companyRegistrationId"])
                ) { notifyWarning(t("customers.toast.empty_company_registration_id")); valid = false; }
            }
            
            if (editCustomer["firstname"] == "" || editCustomer["firstname"] == undefined) { notifyWarning(t("customers.toast.empty_first_name")); valid = false; }
            if (editCustomer["lastname"] == "" || editCustomer["lastname"] == undefined) { notifyWarning(t("customers.toast.empty_last_name")); valid = false; }
            if (editCustomer["address"] == "" || editCustomer["address"] == undefined) { notifyWarning(t("customers.toast.empty_address")); valid = false; }
            if (editCustomer["phone"] == "" || editCustomer["phone"] == undefined) { notifyWarning(t("customers.toast.empty_phone")); valid = false; }
            if(
                editCustomer["phone"] !== undefined &&
                editCustomer["phone"] !== "" &&
                !isOnlyNumPattern.test(editCustomer["phone"])
            ) { notifyWarning(t("customers.toast.invalid_phone")); valid = false; }

            if (valid) {
                resolve(true);
            } else {
                reject();
            }
        });
    }

    function handleEditCustomer(){
        return new Promise((resolve, reject) => {
            isValid().then(() => {
                axios.put(
                    "/api/customers/" + props.customerId,
                    {
                        apArNo: editCustomer["apArNo"],
                    
                        organizationName: editCustomer.organizationName,
                        companyRegistrationId: editCustomer["companyRegistrationId"],
                        shortName: editCustomer["shortName"],
                        countryCodeOrg: editCustomer["countryCodeOrg"],
                    
                        addressType: editCustomer["addressType"],
                        firstname: editCustomer["firstname"],
                        lastname: editCustomer["lastname"],
                        contactPosition: editCustomer["contactPosition"],
                        address: editCustomer["address"],
                        city: editCustomer["city"], 
                        province: editCustomer["province"], 
                        postcode: editCustomer["postcode"],
                        countryCode: editCustomer["countryCode"],
                        email: editCustomer["email"],
                        phone: editCustomer["phone"],
        
                        ehfUser: editCustomer["ehfUser"],
                    },
                    {
                        headers: {'x-access-token': auth.user["token"]}
                    }
                ).then(res=> {
                    if(props.onSave != undefined){props.onSave();}
                    notifySuccess(t("customers.toast.customer_updated"));
                    clearForm();
                    resolve(true);
                });
            }).catch(() => {
                reject();
                return undefined;
            });
        });
    }

    useEffect(() => {
        /* if(props.customerId != undefined){
            getCustomerOrganization();
        } */
        fetchData();
    }, [props.show, props.customerId]);

    return(
        <Modal show={props.show} onHide={() => {if(props.onHide != undefined) props.onHide();}} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{(t("customers.edit"))}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {checkIfPrivatePerson == true ? <div> 
                <p>{(t("customers.privatePerson"))}</p>
                    <Field
                        type="input"
                        title={(t("customers.apArNo")) + "*"}
                        value={editCustomer != undefined ? editCustomer["apArNo"] : ""}
                        placeholder={(t("customers.apArNo_placeholder"))}
                        onChange= {value => setEditApArNo(value)}
                    ></Field>
                    <div className="row">
                        <div className="col col-sm-6">
                            <Field
                                type="input"
                                title={(t("customers.firstname") + '*')}
                                value={editCustomer != undefined ? editCustomer["firstname"] : ""}
                                onChange= {value => setEditFirstName(value)}
                            ></Field>
                        </div>
                        <div className="col col-sm-6">
                            <Field
                                type="input"
                                title={(t("customers.lastname") + '*')}
                                value={editCustomer != undefined ? editCustomer["lastname"] : ""}
                                onChange= {value => setEditLastName(value)}
                            ></Field>
                        </div>
                        <div className="col col-sm-12"> {/*change back to 6 if more felts are added */}
                            <Field
                                type="input"
                                title={(t("customers.phone") + '*')}
                                value={editCustomer != undefined ? editCustomer["phone"] : ""}
                                onChange= {value => setEditPhone(value)}
                            ></Field>
                        </div>
                    </div>
                    <Field
                        type="input"
                        title={(t("customers.email"))}
                        value={editCustomer != undefined ? editCustomer["email"] : ""}
                        onChange= {value => setEditEmail(value)}
                    ></Field>
                    <Field
                        type="input"
                        title={(t("customers.address") + '*')}
                        value={editCustomer != undefined ? editCustomer["address"] : ""}
                        onChange= {value => setEditAddress(value)}
                    ></Field>
                    <div className="row">
                        <div className="col col-sm-6">
                            <Field
                                type="input"
                                title={(t("customers.city"))}
                                value={editCustomer != undefined ? editCustomer["city"] : ""}
                                onChange= {value => setEditCity(value)}
                            ></Field>
                        </div>
                        <div className="col col-sm-6">
                            <Field
                                type="input"
                                title={(t("customers.postCode"))}
                                value={editCustomer != undefined ? editCustomer["postcode"] : ""}
                                onChange= {value => setEditPostcode(value)}
                            ></Field>
                        </div>
                    </div>
                    <hr/>
                    <Button onClick={() => {
                        sendToInvoicing();
                    }}>{(t("customers.sendtoubw"))}</Button>
                </div> 
            : 
                <div> 

                        {/* About the organization */}
                    <p>{(t("customers.company"))}</p>
                        {/* ApArNo */}
                    <Field
                        type="input"
                        title={(t("customers.apArNo"))}
                        value={editCustomer != undefined ? editCustomer["apArNo"] : ""}
                        placeholder={(t("customers.apArNo_placeholder"))}
                        onChange= {value => setEditApArNo(value)}
                    ></Field>
                    <Field
                        type="checkbox"
                        title={(t("customers.ehfuser"))}
                        disabled={editCustomer != undefined && editCustomer["apArNo"] != undefined && editCustomer["apArNo"] != ""}
                        value={editCustomer != undefined ? editCustomer["ehfUser"] : ""}
                        onChange= {value => setEditEhfUser(value)}
                    ></Field>
                    <Field
                        type="input"
                        title={(t("customers.organization") + '*')}
                        value={editCustomer != undefined ? editCustomer["organizationName"] : ""}
                        onChange= {value => setEditOrganizationName(value)}
                    ></Field>
                    <Field
                        type="input"
                        title={(t("customers.companyRegistrationId") + '*')}
                        value={editCustomer != undefined ? editCustomer["companyRegistrationId"] : ""}
                        onChange= {value => setEditCompanyRegistrationId(value)}
                    ></Field>
                    <Field
                        type="input"
                        title={(t("customers.address") + '*')}
                        value={editCustomer != undefined ? editCustomer["address"] : ""}
                        onChange= {value => setEditAddress(value)}
                    ></Field>
                    <div className="row">
                        <div className="col col-sm-6">
                            <Field
                                type="input"
                                title={(t("customers.city"))}
                                value={editCustomer != undefined ? editCustomer["city"] : ""}
                                onChange= {value => setEditCity(value)}
                            ></Field>
                        </div>
                        <div className="col col-sm-6">
                            <Field
                                type="input"
                                title={(t("customers.postCode"))}
                                value={editCustomer != undefined ? editCustomer["postcode"] : ""}
                                onChange= {value => setEditPostcode(value)}
                            ></Field>
                        </div>
                    </div>
                    <hr />
                    <p>{(t("customers.privatePerson"))}</p>
                    <div className="row">
                        <div className="col col-sm-6">
                            <Field
                                type="input"
                                title={(t("customers.firstname") + '*')}
                                value={editCustomer != undefined ? editCustomer["firstname"] : ""}
                                onChange= {value => setEditFirstName(value)}
                            ></Field>
                        </div>
                        <div className="col col-sm-6">
                            <Field
                                type="input"
                                title={(t("customers.lastname") + '*')}
                                value={editCustomer != undefined ? editCustomer["lastname"] : ""}
                                onChange= {value => setEditLastName(value)}
                            ></Field>
                        </div>
                        <div className="col col-sm-12"> {/* set back to 6 if more felts added */}
                            <Field
                                type="input"
                                title={(t("customers.phone") + '*')}
                                value={editCustomer != undefined ? editCustomer["phone"] : ""}
                                onChange= {value => setEditPhone(value)}
                            ></Field>
                        </div>
                    </div>
                    <Field
                        type="input"
                        title={(t("customers.email"))}
                        value={editCustomer != undefined ? editCustomer["email"] : ""}
                        onChange= {value => setEditEmail(value)}
                    ></Field>

                    <Field
                        type="input"
                        title={(t("customers.contactPosition"))}
                        value={editCustomer != undefined ? editCustomer["contactPosition"] : ""}
                        onChange= {value => setEditContactPosition(value)}
                    ></Field>
                    <hr/>
                    <Button
                        onClick={() => {
                            sendToInvoicing();
                        }}
                        disabled={
                            (editCustomer?.["apArNo"] ?? undefined) != undefined &&
                            (editCustomer?.["apArNo"] ?? undefined) != "" &&
                            Number(editCustomer?.["apArNo"] || 0) < 80000
                        }
                    >{(t("customers.sendtoubw"))}</Button>
                </div>}

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => {if(props.onCancel != undefined) props.onCancel(); }}>{(t("customers.cancel"))}</Button>
                <Button onClick={handleEditCustomer}>{(t("customers.save"))}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditCustomerModal;